export default {
  // Global

  // Neutral, light mode
  neutral000: "var(--t-fill-color-neutral-000)",
  neutral010: "var(--t-fill-color-neutral-010)",
  neutral020: "var(--t-fill-color-neutral-020)",
  neutral030: "var(--t-fill-color-neutral-030)",
  neutral040: "var(--t-fill-color-neutral-040)",
  neutral050: "var(--t-fill-color-neutral-050)",
  neutral060: "var(--t-fill-color-neutral-060)",
  neutral070: "var(--t-fill-color-neutral-070)",
  neutral080: "var(--t-fill-color-neutral-080)",
  neutral090: "var(--t-fill-color-neutral-090)",
  neutral100: "var(--t-fill-color-neutral-100)",

  // Interaction
  interactionDefault: "var(--t-fill-color-interaction-default)",
  interactionHover: "var(--t-fill-color-interaction-hover)",
  interactionActive: "var(--t-fill-color-interaction-active)",
  interactionDisabled: "var(--t-fill-color-interaction-disabled)",

  // Status
  statusWarningPrimary: "var(--t-icon-color-status-warning-primary)",
  statusWarningSolid: "var(--t-fill-color-status-warning-solid)",
  statusWarningGhost: "var(--t-fill-color-status-warning-ghost)",
  statusWarningText: "var(--t-text-color-status-warning)",

  statusErrorSolid: "var(--t-fill-color-status-error-solid)",
  statusErrorText: "var(--t-text-color-status-error)",

  // Products - People
  productPeopleDarkest: "var(--t-fill-color-product-people-080)",
  productPeopleDarker: "var(--t-fill-color-product-people-070)",
  productPeopleDark: "var(--t-fill-color-product-people-060)",
  productPeopleLightest: "var(--t-fill-color-product-people-020)",
  productPeopleLighter: "var(--t-fill-color-product-people-030)",
  productPeopleLight: "var(--t-fill-color-product-people-040)",
  productPeopleBase: "var(--t-fill-color-product-people-050)",

  // Products - All
  productAccountsBase: "var(--t-fill-color-product-accounts-050)",
  productCalendarBase: "var(--t-fill-color-product-calendar-050)",
  productCheckInsBase: "var(--t-fill-color-product-checkins-050)",
  productGivingBase: "var(--t-fill-color-product-giving-050)",
  productGroupsBase: "var(--t-fill-color-product-groups-050)",
  productHomeBase: "var(--t-fill-color-product-home-050)",
  productPublishingBase: "var(--t-fill-color-product-publishing-050)",
  productRegistrationsBase: "var(--t-fill-color-product-registrations-050)",
  productServicesBase: "var(--t-fill-color-product-services-050)",

  // People specific

  // Basic colors
  bgColor: "var(--bgColor)",

  // Tapestry-React-specific aliases
  error: "var(--t-fill-color-status-error-solid)",
  errorDark: "var(--t-fill-color-button-delete-solid-hover)",
  errorDarker: "var(--t-fill-color-button-delete-solid-active)",
  errorLighter: "var(--t-fill-color-button-delete-ghost-active)",
  errorLightest: "var(--t-fill-color-button-delete-ghost-hover)",
  linkBackground: "var(--bgColor)",
  primary: "var(--t-fill-color-product-people-050)",
  primaryDark: "var(--t-fill-color-product-people-060)",
  primaryDarker: "var(--t-fill-color-product-people-070)",
  primaryDarkest: "var(--t-fill-color-product-people-080)",
  primaryLight: "var(--t-fill-color-product-people-040)",
  primaryLighter: "var(--t-fill-color-product-people-020)",
  primaryLightest: "var(--local-fill-color-product-people-91)",
  separatorFocus: "var(--t-border-color-status-info)",
  separatorFocusSecondary: "var(--local-fill-color-product-people-88)",
  warning: "var(--t-icon-color-status-warning-primary)",
  warningLight: "var(--t-fill-color-status-warning-solid)",
  warningLighter: "var(--t-fill-color-status-warning-solid)",
  // Tapestry-react token override
  interaction66: "var(--t-fill-color-product-people-050)",
}
